// import React from 'react';
import React, { useState, useEffect } from "react";
import $ from 'jquery';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  // PinterestShareButton
} from "react-share";

import ShareLinkedin from "../../common/images/socialshare/share-linkedin.svg";
import ShareTwitter from "../../common/images/socialshare/share-twitter.svg";
import ShareFb from "../../common/images/socialshare/share-fb.svg";
import ShareWhatsapp from "../../common/images/socialshare/share-whatsapp.svg";
import SharePrint from "../../common/images/socialshare/share-print.svg";
import ShareMail from "../../common/images/socialshare/share-mail.svg";
import ShareCopy from "../../common/images/socialshare/share-copy.svg";
import SiteTrans from "../LangConfig/siteTrans.json";

import { CopyToClipboard } from "react-copy-to-clipboard";
export default function SocialShare({ title, lang }) {
  const [shareUrl,
    setShareUrl] = useState('')
  useEffect(() => handleComponentMounted(), []);
  const handleComponentMounted = () => {
    if (typeof window !== 'undefined') {
      const getUrl = window.location.href
  
      setShareUrl(getUrl)
      setTimeout(() => {
        $('.pagescrollbar').show();
        $('h1.wow').removeClass('wow');
      }, 3000);
    }
  }



  const _copyUrl = () => {
    document.getElementById("linkcopiedStories").classList.add("on");
    setTimeout(function () {
      document.getElementById("linkcopiedStories").classList.remove("on");
    }, 3000);
  };

  return (
    <>
      <div className="col-md-auto share-options d-flex align-items-center">
        <a
          rel="noreferrer"
          href="#/"
          onClick={() => window.print()}
          className="printbtn"
        >
          <img src={SharePrint} alt="img" />
        </a>
        <LinkedinShareButton title={title} url={shareUrl}>
          <img style={{ margin: 10 }} src={ShareLinkedin} alt="img" />
        </LinkedinShareButton>
        <TwitterShareButton title={title} url={shareUrl}>
          <img style={{ margin: 10 }} src={ShareTwitter} alt="img" />
        </TwitterShareButton>
        <FacebookShareButton quote={title} url={shareUrl}>
          <img style={{ margin: 10 }} src={ShareFb} alt="img" />
        </FacebookShareButton>
        <WhatsappShareButton title={title} url={shareUrl}>
          <img style={{ margin: 10 }} src={ShareWhatsapp} alt="img" />
        </WhatsappShareButton>

        <EmailShareButton
          openShareDialogOnClick={true}
          onClick={(e) => e.preventDefault()}
          subject={title}
          url={shareUrl}
        >
          <img style={{ margin: 10 }} src={ShareMail} alt="img" />
        </EmailShareButton>
        <div className="position-relative">
          <CopyToClipboard className="copybtn" text={shareUrl}>
            <img
              onClick={() => _copyUrl()}
              onKeyDown={() => _copyUrl()}
              role="presentation"
              style={{ margin: 10 }}
              src={ShareCopy}
              alt="img"
            />
          </CopyToClipboard>
          <div id="linkcopiedStories" className="font-exsm">{SiteTrans.link_copied_txt[lang]}</div>
        </div>
      </div>
    </>
  );
}
